import getLoadingStatus from '../../api/selectors/getLoadingStatus';
import {KEY, USER_STATUS} from '../constants';

const getInitStatus = state => state?.user?.userOk;

export default state => {
  const status = getInitStatus(state);
  if (typeof status !== 'boolean') {
    const loading = getLoadingStatus(KEY)(state);
    return loading ? USER_STATUS.LOADING : USER_STATUS.NOT_AVAILABLE;
  }
  return status ? USER_STATUS.OK : USER_STATUS.FAILED;
};
